import React from "react";
import { useTranslation } from "react-i18next";

import {
  Box,
  Dialog,
  IconButton,
  Typography,
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  dialogText,
  maxWidth = "sm",
  buttonText = "confirm",
}) => {
  const { t } = useTranslation("common");
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          position: "relative",
          textAlign: "center",
          p: 3,
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="modal-close-button"
      >
        <CloseIcon className="modal-close-icon" />
      </IconButton>

      <DialogContent>
        <Typography className="modal-content-text" sx={{ mt: 3, mb: 2 }}>
          {t(`${dialogText}`)}
        </Typography>
      </DialogContent>

      <Box sx={{ display: "flex", justifyContent: "center", pb: 1 }}>
        <button
          type="button"
          className="button-common button-fill"
          onClick={onConfirm}
        >
          {t(`${buttonText}`)}
        </button>
      </Box>
    </Dialog>
  );
};

export default ConfirmationModal;
